import {
  Component,
  OnInit,
  Renderer2
} from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { CommonService } from '../../services/common/common.service';
import { NgxSpinnerService } from 'ngx-spinner';
import { ToastrService } from 'ngx-toastr';
import { ApiUrlHelper } from '../../common/apiUrlHelper';
import { StorageService, StorageKey } from 'src/app/services/storage/storage.service';
import { ForgotPasswordConstant } from 'src/app/constants/label-constants';

@Component({
  selector: 'app-forgot-password',
  templateUrl: './forgot-password.component.html',
  styleUrls: ['./forgot-password.component.scss']
})
export class ForgotPasswordComponent implements OnInit {
  forgotPasswordForm: FormGroup = this.formBuilder.group({});
  forgotPasswordconstant:any=[];
  public isAuthLoading = false;
  submitted = false;
  constructor(
    private renderer: Renderer2,
    private formBuilder: FormBuilder,
    private router: Router,
    private commonService: CommonService,
    private apiUrl: ApiUrlHelper,
    private spinner: NgxSpinnerService,
    private toster: ToastrService,
    private storageService: StorageService,
  ) { }

  ngOnInit(): void {
    this.forgotPasswordconstant = ForgotPasswordConstant;
    this.initForgotPasswordForm();;
  }

  get forgotPasswordFormControl() {
    return this.forgotPasswordForm.controls;
  }

  goLogin(){
    this.router.navigate(['/login'])
  }

  initForgotPasswordForm() {
    this.forgotPasswordForm = this.formBuilder.group({
      emailAddress: ['', [Validators.required, Validators.pattern(/^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/)]],
    });
  }

  forgotPassword() {
    this.submitted = true;
    this.storageService.removeValue(StorageKey.authToken);
    if (this.forgotPasswordForm.invalid || !this.forgotPasswordForm.value.emailAddress) {
      return;
    }
    this.spinner.show();
    const objData={
      EmailId : this.forgotPasswordForm.value.emailAddress.toLowerCase().trim()
    }
    const apiUrl = this.apiUrl.apiUrl.forgotPassword.ForgetPassword;
    this.commonService.doPost(apiUrl, objData).pipe().subscribe({
      next: async (data) => {
        if (data.success) {
          this.spinner.hide();
          this.router.navigate(['/verification-code' + '/' + btoa(this.forgotPasswordForm.value.emailAddress.toLowerCase().trim())]);
          this.toster.success(data.message);
        }
        else {
          this.spinner.hide();
          this.toster.error(data.message);
        }
      },
      error: (error) => {
        this.spinner.hide();
        this.commonService.checkAuthorize(error);
      }
    });
  }
}


